import "../../../common/common_styles.css";
import { useState, useEffect } from "react";
import classes from "../../CriteriaSubmission/criteriaSubmission.module.css";
import FileUploader from "../../UI/UploadContent/fileUploader";
import { useSelector, useDispatch } from "react-redux";
import util from "../../../styles/utilities.module.css"; // Phase3 buttons

const UploadSampleWorkContent = ({ textLabel, textPlaceholder, nameInStore, selectStoreData, setStoreData, removeIndexDataFromStore, index})  => {
  const storeData = useSelector(selectStoreData);
  const dispatch = useDispatch();
  const [wordCount, setWordCount] = useState(0);
  const [charCount, setCharCount] = useState(null);
  const [text, setText] = useState('');
  const [sampleWorkGrade, setSampleWorkGrade] = useState('');


  // Effect to synchronize the internal text state with the store's state on component mount and whenever the store's state changes
  useEffect(() => {
    if (storeData && storeData[nameInStore+"["+index+"]"]) {
      setText(storeData[nameInStore+"["+index+"]"]);
    }
  }, [storeData, nameInStore+"["+index+"]"]);

  useEffect(() => {
    if (storeData && storeData[nameInStore+"["+index+"]"+"_grade"]) {
      setSampleWorkGrade(storeData[nameInStore+"["+index+"]"+"_grade"]);
    }
  }, [storeData, nameInStore+"["+index+"]"+"_grade"]);




  const handleTextChangeForSampleWork = (event) =>{
    let inputValue = event.target.value;
    const inputWords = inputValue?.split(/\s+/).filter(function (word) {
      return word.length > 0;
    });

    setWordCount(inputWords.length);
    setCharCount(null);

    if (inputWords.length > 10000) {
      inputValue = inputWords.slice(0, 10000).join(" ");
      setWordCount(inputWords.slice(0, 10000).length);
      setCharCount(inputValue.length);
    }

    setText(inputValue);
    dispatch(setStoreData({ [nameInStore+"["+index+"]"]: inputValue }));  // Dynamically set the property based on nameInStore
  }


  const handleSampleWorkGradeChange = (e) => {

    setSampleWorkGrade(e.target.value);
    dispatch(setStoreData({ [nameInStore+"["+index+"]"+"_grade"]: e.target.value }));  // Dynamically set the property based on nameInStore
  }

  return (
    <>
      <div className='boxedElement'>
  <span className='elementBadge'>Sample {index+1}</span>
      {/* Phase3: replace ad-hoc xBadge with standardized ghost small button */}
      <button
        type="button"
        onClick={() => removeIndexDataFromStore(index)}
        className={`${util.btn} ${util['btn--danger']} ${util['btn-sm']}`}
        style={{ position:'absolute', top:'-4px', right:'12px', transform:'translate(70%, -15%)' }}
        aria-label={`Remove Sample ${index+1}`}
      >
        ✕
      </button>
      <div className='flexStretch'>
  <label className={`bottomFlexLabel ${classes.formLabelInline}`} htmlFor="text">{textLabel} </label>
        <div className='gradeInput'>
          <label htmlFor="sampleWorkGrade" className={`midFlexLabel ${classes.formLabelInline}`}>Grade:</label>
          <input value={sampleWorkGrade} 
            className='gradeInputBox'
            onChange={handleSampleWorkGradeChange} 
            placeholder="(Enter your overall grade for this sample)"/>
        </div>

      </div>

      <div className='textAndFileContainer'>
  <div style={{height:"120px"}}  className={classes.textAreaContainer}>
          <textarea
            style={{
                resize: "none",
            
            }}
            name="text"
            className={`${classes.textAreaNoBorder} ${
              wordCount === 10000 ? classes.textAreaMax : ""
            }`}
            onChange={handleTextChangeForSampleWork}
            maxLength={charCount}
            placeholder={textPlaceholder}
            value={text}
          />
          <div className={classes.wordCount}>({wordCount}/10000)</div>
        </div>
  <div style={{ margin: "0px 20px 0px 20px" }}>
          <FileUploader nameInStore={nameInStore+"["+index+"]"+"_files"} selectStoreData={selectStoreData} setStoreData={setStoreData} instance={index} showInfoText={false} />
        </div>       
        
      </div>
      </div>
    </>
  );
};

export default UploadSampleWorkContent;
